module.exports = __webpack_public_path__ + "img/asuransi-surety.e40a7750.svg";